import { put, take, takeLatest } from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes"


function* initLoad() {
    try {
        yield put({
            type: actionTypes.AUTH_CHECK_REQUEST,
            payload: {
                initLoad: true,
            }
        })
  
        const authCheck = yield take([actionTypes.AUTH_CHECK_SUCCESS, actionTypes.AUTH_CHECK_ERROR])

        if(actionTypes.AUTH_CHECK_SUCCESS !== authCheck.type ) {
            throw new Error('Not authentificated')
        }

        yield put({
            type: actionTypes.LOAD_ALL_DATA_REQUEST
        })
    }  catch(e) {
        console.log('error!!!!!', e.message)
    }
}

export function* watchInitLoad() {
    try {
        yield takeLatest(actionTypes.INIT_LOAD_REQUEST, initLoad)
    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}